import { filterMenuDialogId } from 'client/components/Gallery/Header/FilterMenu/constants'

export const isFilterModalHidden = (): boolean => !document.getElementById(filterMenuDialogId)?.hasAttribute('open')
